import { connect } from 'react-redux';

import {
  setExamQuestions,
  setPracticeExam,
  setResultsSummarized,
  setReviewMode,
} from '../actions/practiceExamActions';
import PracticeExamResults from '../components/PracticeExam/practiceExamResults';
import {
  getPracticeExam,
  getResultsSummarized,
} from '../components/PracticeExam/PracticeExamSelectors';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  results: getResultsSummarized(state),
  lastExam: getPracticeExam(state),
});

const mapDispatchToProps = (dispatch) => ({
  setReviewMode: (value) => dispatch(setReviewMode(value)),
  setPracticeExam: (exam) => dispatch(setPracticeExam(exam)),
  setExamQuestions: (questions) => dispatch(setExamQuestions(questions)),
  setResultsSummarized: (results) => dispatch(setResultsSummarized(results)),
  verifyLoggedUser: () => verifyLoggedUser(),
});

const AuthContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PracticeExamResults);

export default AuthContainer;
